const Language = {
  yesNo: (boolean: boolean) => (boolean ? 'Yes' : 'No'),
};

export default Language;
